export const primary = '#17386b'